import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Icon } from "@iconify/react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Call from "@mui/icons-material/Call";
import DescriptionIcon from "@mui/icons-material/Description";
import Download from "@mui/icons-material/Download";

import {
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";

import "./CallHistoryDetails.css";
import ModalTranscription from "../Chat/ModalTranscription";
import Loader from "../Components/Loader";
import formatPhoneNumber from "../Helper/formatPhoneNumber";
import formatTime from "../Helper/formatTime";

import {
  getLogCall,
  getRecordingFiles,
  getScreenRecording,
  setMakeCall,
} from "../Store/Actions/CallAction";

const CallHistoryDetails = ({ data, setSelected }) => {
  const [isHistoryExpanded, setIsHistoryExpanded] = useState(false);
  const [isLogLoading, setIsLogLoading] = useState(true);

  const [isModalTranscriptionShown, setIsModalTranscriptionShown] =
    useState(false);

  const [isRecordingError, setIsRecordingError] = useState(false);
  const [isRecordingLoading, setIsRecordingLoading] = useState(true);
  const [isRecordingPlaying, setIsRecordingPlaying] = useState(false);

  const [isScreenRecordingLoading, setIsScreenRecordingLoading] =
    useState(true);

  const [isSeekVoiceAllowed, setIsSeekVoiceAllowed] = useState(null);
  const [logHistoryCall, setlogHistoryCall] = useState([]);
  const [recording, setRecording] = useState(null);
  const [screenRecording, setScreenRecording] = useState("");
  const [selectedTranscription, setSelectedTranscription] = useState("");
  const dispatch = useDispatch();

  const { agentPermission, CurrentState, myInfo, sipAccount } = useSelector(
    (state) => state.auth
  );

  const recordingRef = useRef(null);
  const userLevel = myInfo.user.Level;

  useEffect(() => {
    setIsRecordingLoading(true);
    setIsLogLoading(true);
    const abortController = new AbortController();

    getRecordingFiles(data.RecMessageID, abortController.signal)
      .then((response) => {
        if (response.status) {
          setRecording(response.data);

          recordingRef.current = new Audio(
            `data:audio/wav;base64,${response.data.filebytes}`
          );

          setIsRecordingLoading(false);
          setIsRecordingError(false);
        } else {
        if (!response.error.includes("canceled")) {
          console.log("errorz", response.error);
          setIsRecordingError(true);
          setIsRecordingLoading(false);
        }}
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.log("err", err);
          setIsRecordingError(true);
          setIsRecordingLoading(false);
        }
      });

    if (data?.CallType === "INBOUND" && data.CalledNo === "6000") {
      setIsScreenRecordingLoading(true);
      const fileName = data.RecMessageID?.split("_").pop();
      const uniqueID = fileName?.substring(0, fileName.lastIndexOf("."));

      getScreenRecording(uniqueID)
        .then((response) => {
          if (response.status) {
            setScreenRecording(response.data);
            setIsScreenRecordingLoading(false);
          } else {
            console.log("error", response.error);
            setIsScreenRecordingLoading(false);
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsScreenRecordingLoading(false);
        });
    }

    //logcallUntukSearchCallHistoryContact
    getLogCall({
      agentlevel: userLevel,
      dateStart: moment().subtract(2, "years").format("YYYY-MM-DD"),
      dateEnd: moment().format("YYYY-MM-DD"),
      searchkeyword:
        data.CallType === "INBOUND" ? data.CallerNo : data.ConnectedNo,
    })
      .then((response) => {
        if (response.status) {
          setlogHistoryCall(response.data.calls);
          setIsLogLoading(false);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    return () => {
      abortController.abort();
    };
  }, [data]);

  // Get seek voice permission
  useEffect(() => {
    const seekVoicePermission = agentPermission.find(
      (permission) => permission.PermissionCode === "User.SeekVoice"
    );

    if (seekVoicePermission && seekVoicePermission.PermissionAccess === "A") {
      setIsSeekVoiceAllowed(true);
    } else {
      setIsSeekVoiceAllowed(false);
    }
  }, [agentPermission]);

  // Event listener for audio `ended` event
  useEffect(() => {
    recordingRef.current &&
      recordingRef.current.addEventListener("ended", () =>
        setIsRecordingPlaying(false)
      );

    return () => {
      recordingRef.current &&
        recordingRef.current.removeEventListener("ended", () =>
          setIsRecordingPlaying(false)
        );
    };
  }, [recordingRef.current]);

  function checkString(str) {
    // Check if "08" is at the start of the string
    if (str.charAt(0) === "0" && str.charAt(1) === "8") {
      // Check if there is any string in front of "08"
      const inFront = str.substring(4); // Get the string after "08"
      const containPrefix = str.charAt(0) === "9" || str.charAt(1) === "9";
      if (inFront) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  return (
    <section className="call-history-details">
      <header className="call-history-header">
        <ArrowBackIosNewIcon
          className="back-button"
          onClick={() => setSelected(null)}
        />
        <div className="info">
          <p className="name">{data?.ContactName}</p>
          <p className="number">
            {formatPhoneNumber(
              data?.CallType === "OUTBOUND"
                ? data?.CalledNo.length < 4
                  ? data?.CallerNo.includes("+62")
                    ? data?.CallerNo.replace(/\+62/g, "0")
                    : checkString(data?.CallerNo)
                    ? data?.CallerNo.replace(/^(.)(08)/, "$2")
                    : data?.CallerNo.charAt(0) === "9" ||
                      data?.CallerNo.charAt(1) === "9"
                    ? data?.CallerNo.replace(/^(.)(08)/, "$2")
                    : data?.CallerNo.replace(/^(8)/, "0$1")
                  : data?.CalledNo
                : data?.CallerNo.includes("+62")
                ? data?.CallerNo.replace(/\+62/g, "0")
                : data?.CallerNo.replace(/^(8)/, "0$1")
              //remove everything infront 08
              //data?.CallerNo.replace(/^(.)(08)/, "$2")
            )}

            {data.IsWABACall && " - From WhatsApp"}
          </p>
        </div>
        <Button
          variant="contained"
          className="button-quick-call"
          disabled={CurrentState !== "READY" || !sipAccount}
          onClick={() =>
            dispatch(
              setMakeCall({
                agentStatus: CurrentState,

                phoneNo:
                  data?.CallType === "INBOUND"
                    ? data?.CallerNo.replace(/-/g, "")
                    : data?.CalledNo.replace(/-/g, ""),
              })
            )
          }
        >
          <Call />
        </Button>
      </header>

      <section className="details-card">
        <div className="card-title">
          <Icon height="28" icon="material-symbols:call-quality" width="28" />
          Call History Details
        </div>

        <div className="card-contents">
          {data?.CallStatus === "ANSWERED" && data?.CalledNo !== "6000" ? (
            <div className="recording">
              {isRecordingLoading ? (
                <Loader desc={"Fetching Files"} />
              ) : isRecordingError ? (
                <p className="error">
                  Sorry, there was a problem loading the recording file.
                </p>
              ) : (
                <>
                  <div className="filename">
                    <Icon height="20" icon="ph:file-bold" width="20" />

                    <p>{recording.filename}</p>
                  </div>

                  <div
                    className={`controls ${
                      !isSeekVoiceAllowed ? "simple" : ""
                    }`}
                  >
                    {isSeekVoiceAllowed ? (
                      // Audio with controls if seek voice is allowed
                      <audio
                        controls
                        controlsList="nodownload"
                        src={`data:audio/wav;base64,${recording?.filebytes}`}
                      />
                    ) : (
                      // Play/pause button if seek voice is not allowed
                      <Tooltip
                        arrow
                        title={isRecordingPlaying ? "Pause" : "Play"}
                      >
                        <Button
                          className="download-button"
                          variant="contained"
                          onClick={() => {
                            if (isRecordingPlaying) {
                              recordingRef.current.pause();
                              setIsRecordingPlaying(false);
                            } else {
                              recordingRef.current.play();
                              setIsRecordingPlaying(true);
                            }
                          }}
                        >
                          {isRecordingPlaying ? (
                            <Icon height="24" icon="ic:round-pause" />
                          ) : (
                            <Icon height="24" icon="ph:play-fill" />
                          )}
                        </Button>
                      </Tooltip>
                    )}

                    <a
                      download={recording?.filename}
                      href={`data:audio/wav;base64,${recording?.filebytes}`}
                    >
                      <Tooltip arrow title="Download recording">
                        <Button variant="contained" className="download-button">
                          <Download />
                        </Button>
                      </Tooltip>
                    </a>

                    {/* Temp hidden */}
                    {/* <Tooltip arrow title="Show transcription">
                      <Button
                        variant="contained"
                        className="download-button"
                        onClick={() => {
                          setSelectedTranscription(
                            data.RecMessageID?.replace("rds", "internal")
                          );

                          setIsModalTranscriptionShown(true);
                        }}
                      >
                        <DescriptionIcon />
                      </Button>
                    </Tooltip> */}
                  </div>
                </>
              )}
            </div>
          ) : (
            ""
          )}

          {data?.CallType === "INBOUND" && data?.CalledNo === "6000" && (
            <div className="recording">
              {isScreenRecordingLoading ? (
                <Loader desc={"Fetching Files"} />
              ) : (
                <div className="video-container">
                  <video controls>
                    <source
                      src={`${process.env.REACT_APP_FILE_SERVER_URL}/screen-recording/${screenRecording}`}
                      type="video/webm"
                    />
                  </video>

                  <a
                    download={screenRecording}
                    href={`${process.env.REACT_APP_API_URL}call/downloadscreenrecording/${screenRecording}`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <IconButton>
                      <Icon
                        color="#fff"
                        height="18"
                        icon="bxs:download"
                        width="18"
                      />
                    </IconButton>
                  </a>
                </div>
              )}
            </div>
          )}

          <div className="details">
            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon
                        height="24"
                        icon="material-symbols:outbound-outline-rounded"
                        rotate={data?.CallType === "OUTBOUND" ? 0 : 2}
                        width="24"
                      />
                    </InputAdornment>
                  ),
                }}
                label="Call Type"
                value={
                  data?.CallType === "OUTBOUND"
                    ? "Outbound"
                    : data?.IsVideoCall
                    ? "Inbound Video"
                    : "Inbound"
                }
              />
            </div>

            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                label="Call Time"
                value={formatTime(data?.CallTime, true)}
              />
            </div>

            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                label="Handle By"
                value={data?.AgentName}
              />
            </div>

            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                label="Caller Number"
                value={data?.CallerNo}
              />
            </div>

            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                label="Called Number"
                value={data?.CalledNo}
              />
            </div>

            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                label="Duration"
                value={moment
                  .utc(
                    moment
                      .duration(data?.TalkDurationSecond, "seconds")
                      .asMilliseconds()
                  )
                  .format("HH:mm:ss")}
              />
            </div>

            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                label="Connect Time"
                value={formatTime(data?.ConnectTime, true)}
              />
            </div>

            <div className="item">
              <TextField
                fullWidth
                inputProps={{ readOnly: true }}
                label="Disconnect Time"
                value={formatTime(data?.DisconnectTime, true)}
              />
            </div>
          </div>
        </div>
      </section>

      {data?.CallType === "INBOUND" && data?.CalledNo === "6000" ? (
        ""
      ) : (
        <section
          className={`history-card ${isHistoryExpanded ? "expanded" : ""}`}
        >
          <div className="card-title">
            <div className="title">
              <Icon height="28" icon="bxs:user-detail" width="28" />
              Call History by Contact
            </div>

            <IconButton
              onClick={() => setIsHistoryExpanded(!isHistoryExpanded)}
            >
              {isHistoryExpanded ? (
                <Icon
                  color="white"
                  height="30"
                  icon="material-symbols:keyboard-arrow-up-rounded"
                  width="30"
                />
              ) : (
                <Icon
                  color="white"
                  height="30"
                  icon="material-symbols:keyboard-arrow-down-rounded"
                  width="30"
                />
              )}
            </IconButton>
          </div>

          {isHistoryExpanded && (
            <div className="card-contents">
              <div className="list">
                {/* {dummy.history.map((item, index) => { */}
                {isLogLoading ? (
                  <Loader desc={"Fetching Logs"} />
                ) : (
                  logHistoryCall.map((item, index) => {
                    return (
                      <div className="list-item" key={index}>
                        <div className="contact-info">
                          <p className="contact-name">{data.ContactName}</p>

                          <p className="contact-number">
                            {item?.CallType === "INBOUND"
                              ? formatPhoneNumber(item.CallerNo)
                              : formatPhoneNumber(item.ConnectedNo)}
                          </p>

                          <div className="agent-data">
                            <Icon
                              height="18"
                              icon="material-symbols:outbound-outline-rounded"
                              rotate={item.CallType === "OUTBOUND" ? 0 : 2}
                              width="18"
                            />

                            {userLevel > 0 && (
                              <div className="contact-by">
                                <Icon
                                  height="18"
                                  icon="material-symbols:support-agent-rounded"
                                  width="18"
                                />
                                {item.AgentName}
                              </div>
                            )}

                            {userLevel > 0 && item.CampaignName && (
                              <span>-</span>
                            )}

                            {item.CampaignName && (
                              <div className="campaign-name">
                                <Icon
                                  height="18"
                                  icon="material-symbols:flag"
                                  width="18"
                                />

                                <p>{item.CampaignName}</p>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="contact-detail">
                          <div className="detail-status">
                            <p className="status-text">
                              {item.CallStatus === "ANSWERED"
                                ? "Call Connected"
                                : "Call Not Connected"}
                            </p>

                            {item.CallStatus === "ANSWERED" ? (
                              <Icon
                                color="#0343c7"
                                height="24"
                                icon="material-symbols:call"
                                width="24"
                              />
                            ) : (
                              <Icon
                                color="#F97427"
                                height="24"
                                icon="material-symbols:phone-missed"
                                width="24"
                              />
                            )}
                          </div>

                          <p className="contact-time">
                            {formatTime(item.CallTime)}
                          </p>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          )}
        </section>
      )}

      {isModalTranscriptionShown && (
        <ModalTranscription
          recMessageID={selectedTranscription}
          onClose={() => setIsModalTranscriptionShown(false)}
        />
      )}
    </section>
  );
};

export default CallHistoryDetails;
